import { render, staticRenderFns } from "./AlertInfoText.vue?vue&type=template&id=d09ab24a&scoped=true"
import script from "./AlertInfoText.vue?vue&type=script&lang=js"
export * from "./AlertInfoText.vue?vue&type=script&lang=js"
import style0 from "./AlertInfoText.vue?vue&type=style&index=0&id=d09ab24a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09ab24a",
  null
  
)

export default component.exports